__turbopack_context__.v({
  "align-center": "text-module-scss-module__S6Nr3a__align-center",
  "align-left": "text-module-scss-module__S6Nr3a__align-left",
  "align-right": "text-module-scss-module__S6Nr3a__align-right",
  "heading": "text-module-scss-module__S6Nr3a__heading",
  "normal": "text-module-scss-module__S6Nr3a__normal",
  "root": "text-module-scss-module__S6Nr3a__root",
  "size-inherit": "text-module-scss-module__S6Nr3a__size-inherit",
  "size-lg": "text-module-scss-module__S6Nr3a__size-lg",
  "size-md": "text-module-scss-module__S6Nr3a__size-md",
  "size-sm": "text-module-scss-module__S6Nr3a__size-sm",
  "size-xl": "text-module-scss-module__S6Nr3a__size-xl",
  "size-xxl": "text-module-scss-module__S6Nr3a__size-xxl",
  "tone-destructive": "text-module-scss-module__S6Nr3a__tone-destructive",
  "tone-disabled": "text-module-scss-module__S6Nr3a__tone-disabled",
  "tone-inherit": "text-module-scss-module__S6Nr3a__tone-inherit",
  "tone-primary": "text-module-scss-module__S6Nr3a__tone-primary",
  "tone-secondary": "text-module-scss-module__S6Nr3a__tone-secondary",
  "tone-success": "text-module-scss-module__S6Nr3a__tone-success",
  "tone-warning": "text-module-scss-module__S6Nr3a__tone-warning",
  "weight-bold": "text-module-scss-module__S6Nr3a__weight-bold",
  "weight-medium": "text-module-scss-module__S6Nr3a__weight-medium",
  "weight-regular": "text-module-scss-module__S6Nr3a__weight-regular",
  "weight-semibold": "text-module-scss-module__S6Nr3a__weight-semibold",
});
